/**
 * https://tech.yandex.ru/maps/jsbox/2.1/placemark_layout
 * https://tech.yandex.ru/maps/jsbox/2.1/placemark_shape
 * **/

export const createIconLayout = () => {
	const iconLayout = ymaps.templateLayoutFactory.createClass(
		`<div class="map-pin $[properties.complex]"><img src="$[properties.hrefImage]" data-href="$[properties.complexHref]" alt="ЖК"></div>`,
		{
			build: function () {
				iconLayout.superclass.build.call(this);

				const element = this.getParentElement().getElementsByTagName(`img`)[0];
				const markerGroup = this.getData().properties.group;
				const groupColor = this.getData().properties.groupColor;
				const markerSubway = this.getData().properties.subwayLine;
				const markerClass = markerGroup ? `grouped-map-marker` : markerSubway ? `subway--line-${markerSubway}` : `map-marker`;
				const width = this.getData().properties.size.width;
				const height = this.getData().properties.size.height;
				const imageTop = markerGroup ? -height : -height;
				const imageLeft = markerGroup ? -width / 2 : 0;
				const shapeCoordinates = markerGroup ? [
					[-width / 2, -height],
					[width / 2, 0],
				] : [
					[-width / 2, -height],
					[width / 2, 0]
				];

				element.classList.add(markerClass);
				element.closest(`div.map-pin`).classList.add(markerClass);
				this.getParentElement().firstChild.style.display = `block`;
				if ( markerGroup && groupColor )
				{
					element.closest(`div.map-pin`).style.backgroundColor = groupColor;
				}
				if ( !markerGroup )
				{
					this.getParentElement().firstChild.style.transform = `translateX(-50%)`;
				}

				this._element.style.position = `relative`;
				this._element.style.top = `${imageTop}px`;
				this._element.style.left = `${imageLeft}px`;
				this._element.style.width = `${width}px`;
				this._element.style.height = `${height}px`;

				const shapeRectangle = {
					type: `Rectangle`,
					coordinates: shapeCoordinates,
				};

				this.getData().options.set(`shape`, shapeRectangle);
			}
		}
	);
	
	return iconLayout;
};
